import React from 'react';
import { Layout } from '../components/Layout';
import AboutSection from '../components/AboutSection';
import TeamSection from '../components/TeamSection';

export default function About() {
  return (
    <Layout>
      <AboutSection id="about-company" />
      <TeamSection id="team" />
    </Layout>
  );
}
